import type { Request } from '../../index'
import { EncashmentsAction, EncashmentsStatusAction, OperationResultType } from 'app/dataTypes/reports/data/finances/encashments/action'


const apiDatefomat = "YYYY-MM-DD"

export type ApiParams = {
  sale_point_id: number,                   // точка продаж
  date: string,                            // Дата
  operation_type: 'accept' | 'reject',       // тип операции, accept|reject
  comment?: string                         // обязателен в случае reject
}

type ResultApi = {
  result: "success",
  operation_type: "accept" | 'reject',
  sum: number
}

export const convertParams = (params: EncashmentsStatusAction): [ApiParams, null] => {
  const { salePointId, date, comment, action } = params
  if (action !== 'accept' && action !== 'reject') {
    throw new Error('Неверно передан параметр action в POST_ENCASHMENT_ACTION')
  }
  return [{
    sale_point_id: parseInt(salePointId, 10),
    date: date.getString(apiDatefomat),
    operation_type: action,
    comment
  }, null]
}

const convertOperaions = (action: string) => {
  if (action === EncashmentsAction.Accept) return EncashmentsAction.Accept
  if (action === EncashmentsAction.Reject) return EncashmentsAction.Reject
  return false
}

export const convertResult = (resultApi: ResultApi): OperationResultType | false => {
  if (resultApi.result === 'success') {
    const {
      operation_type: operationType,
      sum
    } = resultApi
    const action = convertOperaions(operationType)
    if (!action) return false
    return {
      operationType: action,
      sum
    }
  } else return false
}

export const POST_ENCASHMENT_ACTION: Request<EncashmentsStatusAction, OperationResultType | false, void> = [
  'food/encashment',
  'post',
  ['data'],
]
